import { AnnouncementsWorkspace } from '@/components/announcements/announcements-workspace'

export function AdminAnnouncements() {
  return <AnnouncementsWorkspace basePath="/admin/announcements" />
}
